module.exports = __webpack_public_path__ + "static/img/service03.e13f23f2.png";